import * as commonFields from "./common-fields";
import type { BaseWorkGroupDto } from "@ckweb/ckfetch/connectables/equipmentAreaManagement";

type WorkGroupDataItem = BaseWorkGroupDto & {
  number?: number;
  systemCreated?: boolean;
};

export const workGroupSchema: $ck.z.ZodType<WorkGroupDataItem> = $ck.z.object({
  number: commonFields.optionalNumberField(),
  name: commonFields.requiredStringField().max(25),
  active: commonFields.booleanField(),
  comment: commonFields.stringOrEmptyField(),
  changeoverLevel: commonFields.requiredNumericListItemField(),
  defaultAllSelection: commonFields.booleanField(),
});

export type WorkGroupSchema = $ck.z.TypeOf<typeof workGroupSchema>;
